// src/components/navbar/AvatarMenu.jsx
import React, { useEffect, useRef, useState } from "react";

export default function AvatarMenu({
  user,
  displayName,  // nombre “bonito” (empresa / trade_name)
  avatarUrl,     // logo de la empresa si existe
  onProfile,
  onAdmin,
  onLogout,
}) {
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);
  const hoverTimer = useRef(null);

  const name =
    displayName ||
    user?.business_name ||
    user?.name ||
    "Usuario";

  const initials = (name || "U")
    .split(/\s+/)
    .map((w) => w?.[0] || "")
    .join("")
    .slice(0, 2)
    .toUpperCase();

  // --- Abrir al pasar el mouse / cerrar al salir (desktop) ---
  const handleMouseEnter = () => {
    clearTimeout(hoverTimer.current);
    setOpen(true);
  };
  const handleMouseLeave = () => {
    clearTimeout(hoverTimer.current);
    hoverTimer.current = setTimeout(() => setOpen(false), 120);
  };

  // --- Click/tap (mobile) ---
  const handleToggleClick = () => setOpen((o) => !o);

  // --- Cerrar si se hace click fuera ---
  useEffect(() => {
    const onDocClick = (e) => {
      if (!rootRef.current) return;
      if (!rootRef.current.contains(e.target)) setOpen(false);
    };
    const onEsc = (e) => {
      if (e.key === "Escape") setOpen(false);
    };
    document.addEventListener("mousedown", onDocClick);
    document.addEventListener("keydown", onEsc);
    return () => {
      document.removeEventListener("mousedown", onDocClick);
      document.removeEventListener("keydown", onEsc);
    };
  }, []);

  return (
    <div
      ref={rootRef}
      className="relative"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <button
        type="button"
        className="flex items-center gap-3 bg-white/10 hover:bg-white/20 text-white px-4 py-2 rounded-full border border-white/30"
        onClick={handleToggleClick} // tap/click (mobile o desktop)
        aria-haspopup="menu"
        aria-expanded={open}
      >
        <span className="w-9 h-9 rounded-full overflow-hidden bg-white/80 flex items-center justify-center ring-2 ring-white/50">
          {avatarUrl ? (
            <img
              src={avatarUrl}
              alt="avatar"
              className="w-full h-full object-cover"
              onError={(e) => {
                e.currentTarget.style.display = "none";
              }}
            />
          ) : (
            <span className="text-[#0B4A8F] font-bold">{initials}</span>
          )}
        </span>
        <span className="font-semibold">{name}</span>
        <span className="opacity-80">▾</span>
      </button>

      {/* Dropdown */}
      {open && (
        <div
          role="menu"
          className="absolute right-0 mt-2 w-64 bg-white shadow-xl rounded-xl overflow-hidden z-50"
        >
          <div className="px-4 py-2 text-sm text-gray-500">Bienvenido</div>
          <div className="px-4 pb-2 font-semibold text-gray-900">{name}</div>
          <hr />
          {onProfile && (
            <button
              role="menuitem"
              className="w-full text-left px-4 py-3 hover:bg-gray-50 font-medium text-[#0B4A8F]"
              onClick={() => {
                setOpen(false);
                onProfile();
              }}
            >
              Mi perfil
            </button>
          )}
          {onAdmin && (
            <button
              role="menuitem"
              className="w-full text-left px-4 py-3 hover:bg-gray-50 font-medium text-[#0B4A8F]"
              onClick={() => {
                setOpen(false);
                onAdmin();
              }}
            >
              Área de trabajo
            </button>
          )}
          {onLogout && (
            <button
              role="menuitem"
              className="w-full text-left px-4 py-3 hover:bg-gray-50 font-semibold text-red-600"
              onClick={() => {
                setOpen(false);
                onLogout();
              }}
            >
              Cerrar sesión
            </button>
          )}
        </div>
      )}
    </div>
  );
}
